var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtcOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H13L16 3.6V4V6V14C16 15.1 15.1 16 14 16H2C0.9 16 0 15.1 0 14V6V4V3.6L3 0ZM2 14H14V6H2V14ZM3.94 2L2.27 4H13.74L12.07 2H3.94ZM10 10H6C5.45 10 5 9.55 5 9C5 8.45 5.45 8 6 8H10C10.55 8 11 8.45 11 9C11 9.55 10.55 10 10 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtcOnly);
export default __webpack_public_path__ + "static/media/otcOnly.e03a01973f40d2ff550e4e7b3642441a.svg";
export { ForwardRef as ReactComponent };